export default __webpack_public_path__ + "static/media/BPS-Banner_Home.c3e833d0.png";